{
  "replaceMessage": "Datei zum Ersetzen ablegen"
}
